import { DataShareholderInvestorTct, DataUserResponse } from '@dealstack/shared/lib/generated';
import { createAction, createReducer } from '@reduxjs/toolkit';
import {
	applyUserName,
	userNameUpdated,
} from '@dealstack/frontend/shared/mechanism/redux/reducers/user/user';

interface UserStateData extends DataUserResponse {
	investor: DataShareholderInvestorTct;
}

export interface UserState {
	isLoading: boolean;
	investorId: string | undefined;
	dealId: string | undefined;
	mipId: string | undefined;
	data: UserStateData | null;
}

export const fetchUserStart = createAction('user/getData/start');
export const fetchUserSuccess = createAction<UserStateData>('user/getData/success');
export const fetchUserError = createAction<unknown>('user/getData/error');
export const logout = createAction('user/logout');

const initialState: UserState = {
	isLoading: false,
	investorId: undefined,
	dealId: undefined,
	mipId: undefined,
	data: null,
};

// https://redux-toolkit.js.org/api/createReducer
export const userReducer = createReducer(initialState, (builder) => {
	builder
		.addCase(fetchUserStart, (state) => {
			state.isLoading = true;
		})
		.addCase(fetchUserSuccess, (state, action) => {
			state.data = action.payload;
			state.isLoading = false;
			state.dealId = action.payload.investor?.mip?.deal?.id;
			state.mipId = action.payload.investor?.mipId;
			state.investorId = action.payload.investor?.id;
		})
		.addCase(fetchUserError, (state) => {
			state.isLoading = false;
		})
		.addCase(userNameUpdated, (state, action) => {
			applyUserName(state.data, action.payload);
		})
		.addCase(logout, (state) => {
			state.isLoading = false;
			state.data = null;
		});
});
